import { Link } from "react-router";
import { AwardsMenu } from "@events-awards/utils/types";

interface SIASideMenuProps {
  /** The data of the navigation, will be displayed for mobile. */
  data: AwardsMenu[];
}

/**
 * Events Awards SIA side menu component
 */
const SIASideMenu = ({ data }: SIASideMenuProps): React.ReactElement => {
  return (
    <nav
      data-testdata-testid="events-sia-side-menu-component"
      className="mb-5 flex flex-col bg-gray-250 text-center"
    >
      {data.map(({ link, text }, index) => {
        return (
          <Link
            key={`${text}${index}`}
            className="block px-3 py-2 font-poppins text-base font-semibold hover:bg-gray-175"
            to={link}
            reloadDocument
          >
            {text}
          </Link>
        );
      })}
    </nav>
  );
};

export default SIASideMenu;
